import { Box, Drawer, ModalProps, useTheme } from "@mui/material";
import { Images } from "../../../models/assets-files";
import Image from "../../common/Image";
import UserAvatar from "../../common/UserAvatar";
import useScreen from "../../common/UseScreen";
import AppSideMenuList from "./AppSideMenuList";
import { AppBarCategoryItem } from "../../../data/app-side-menu-list-items";
import { ImageService } from "../../../services/image.service";
import { useSelector } from "react-redux";
import { StoreState } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import { ContactUsText } from "../../../data/texts";

interface AppSideMenuProps {
  isOpen: boolean;
  handleCloseDrawer: VoidFunction;
  handleItemClick: (categoryItem: AppBarCategoryItem) => void;
  selectedItemPath: string;
}

const AppSideMenu = ({
  isOpen,
  handleCloseDrawer,
  selectedItemPath,
  handleItemClick,
}: AppSideMenuProps) => {
  const theme = useTheme();
  const { isDesktop } = useScreen();
  const navigate = useNavigate();
  const user = useSelector((state: StoreState) => state.user.loggedInUser);

  const drawerModalProps: Partial<ModalProps> = {
    sx: {
      "&.MuiModal-root": {
        pointerEvents: isDesktop ? "none" : "all",
        cursor: "pointer",
      },
    },
  };

  const onLogoClick = () => {
    if (user) {
      if (user.role === "admin" || user.role === "agent") {
        navigate("/agent-homepage");
        return;
      }
      navigate("/");
    }
  };

  return (
    <Drawer
      disableEnforceFocus={isDesktop}
      hideBackdrop={isDesktop}
      onClose={handleCloseDrawer}
      open={isDesktop ? true : isOpen}
      ModalProps={drawerModalProps}
      sx={{ height: "100%" }}
      PaperProps={{
        style: { background: theme.palette.primary.main, pointerEvents: "all" },
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: theme.custom.appDrawerWidth,
          overflowY: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Box
          sx={{
            flexGrow: "1",
            paddingTop: "20px",
            paddingInlineStart: "20px",
            marginInlineEnd: "20px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Image
            hideSkeleton
            sx={{
              width: "88px",
              height: "34px",
              cursor: "pointer",
              marginBottom: "35px",
            }}
            onClick={onLogoClick}
            src={ImageService.getLocalImgPath(
              Images.Folders.GENERAL,
              Images.General.Logo
            )}
          />
          <UserAvatar
            sx={{ marginBottom: "15px", cursor: "pointer" }}
            subtitle="Hello,"
            username={user?.fullName}
          />
          <AppSideMenuList
            handleItemClick={handleItemClick}
            selectedItemPath={selectedItemPath}
          />
        </Box>
        <Box
          sx={{
            backgroundColor: theme.palette.secondary.main,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            minHeight: "48px",
          }}
          onClick={() => navigate("/contact-us")}
        >
          {ContactUsText.CONTACT_US}
        </Box>
      </Box>
    </Drawer>
  );
};

export default AppSideMenu;
